import App from './fitcrm-pro';
export default App;